export default {
      id: "common__docs-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__docs",
      toString: function () {
        return this.url;
      }
    }